import moment from 'moment';

export const NOTHING = '';
export function getEcheaciersLigneByDate(echeanciers, date) {
  const endMonth = moment(date).endOf('month');
  const ech = echeanciers
    .reduce((acc, ech) => {
      const dateEch = ech.facture?.dateDevisCommande || ech.datePrevisionnelleFacturation;

      if (moment(date).isSameOrBefore(dateEch) && endMonth.isSameOrAfter(dateEch)) {
        let echeancier = null;
        if (ech.facture && !acc.find(el => el.id === ech.id)) echeancier = ech;
        else if (!ech.facture) echeancier = ech;
        if (echeancier) {
          echeancier.montantAPrendre = ech.facture?.montantHt || ech.montant;
          echeancier.dateEcheancier = dateEch;
          acc.push(echeancier);
        }
      }
      return acc;
    }, []);
  return ech;
}
